export const getTowerTypes = ({ tower }) => tower.types;

export const getTowerTicket = ({ tower }) => tower.ticket;

export const getTowerHistory = ({ tower }) => tower.history;

export const getTowerLeaders = ({ tower }) => tower.leaders;
